import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['totalAmountInput', 'totalAmountInputHidden'];

  updateMontantTotal() {
    const ttcAmountInputs = this.element.querySelectorAll('.line-ttc-amount-input')
    let totalAmount = 0.0;
    ttcAmountInputs.forEach(elem => {
      const parentForm = elem.closest(".nested-form-container")
      if (parentForm.classList.contains('!hidden'))
        return;
      if (elem.value != "" && elem.value != null && typeof(elem.value) != "undefined") {
        totalAmount += parseFloat(elem.value);
      }
    });
    this.totalAmountInputTarget.value = totalAmount;
    this.totalAmountInputHiddenTarget.value = totalAmount;
  }
}
